import { useEffect } from "react"
import config from "../config.json";

const files = {
  "cssFiles":[
    {
      "id": "appkit-index-css",
      "file":"index.css"
    }
  ]
}

function loadCss(href) {
  return new Promise((resolve, reject) => {
    // prevent duplicate load
   if (document.querySelector("#" + href.id)) {
      resolve("already loaded");
      return;
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.id = href.id;
    link.href = `${config.appkitPath}/${href.file}?version=${window.aiVersion}`;

    link.onload = () => resolve("loaded");
    link.onerror = () => reject(new Error(`Failed to load CSS: ${href.file}`));
    document.head.appendChild(link);
  });
}

function loadAssets(css) {
  return Promise.all(css.map(function(v){
    return loadCss(v);
  }));
}

const DivkitEditor = function(){
     useEffect(function(){
      // initializeEditorsMe is provided by the AppKit bundle the host page
      // loads. It may not be defined yet — or at all — when this effect runs,
      // so calling it unguarded threw a TypeError (AI-BUILDER-63).
      const boot = function(){
        if(typeof window.initializeEditorsMe === "function") {
          window.initializeEditorsMe();
        }
        else {
          console.warn("DivkitEditor: window.initializeEditorsMe unavailable, skipping init");
        }
      };
      // The stylesheet is cosmetic, so a CDN hiccup shouldn't stop the editor
      // from booting. Previously a failed <link> load rejected with nothing to
      // catch it, which surfaced as an unhandled rejection AND left the pane
      // blank because init only ran inside .then() (AI-BUILDER-5P).
      loadAssets(files.cssFiles).then(boot).catch(function(err){
        console.warn("DivkitEditor: asset load failed, booting unstyled", err);
        boot();
      });
    }, [])
    return <div className="divkit-wrapper w-100 h-100">
      <div id="appkit-editor" className="w-100 h-100"></div>
    </div>
}

export default DivkitEditor
